import React from "react";
import Grid from "@material-ui/core/Grid";
import ButtonBase from "@material-ui/core/ButtonBase";
import { Container, Divider } from "@material-ui/core";
import { QRCodeCanvas } from "qrcode.react";
import { useInvAF } from "../../../St/Reviews/UseStyle";

function NewHeadCom(props) {

    const { found, sta, inv, locInv, premiApp, page } = props;
    const clas = useInvAF();
    const styfOther = {
        fontSize: "1rem", display: "flex", alignItems: "center", alignContent: "left",
        fontWeight: "bold", whiteSpace: "pre-line", textAlign: "center", fontSize: "1.1rem"
    };
    const styleNameA = { fontWeight: "bold", textAlign: "right", fontSize: "1.3rem" };
    return (
        <Grid item container
        >
            <Grid
                container
                item xs={12}
                style={{ fontWeight: "bold", fontFamily: "Amiri-Regular", padding: 0, direction: "rtl" }}
            >
                <Grid container item xs={12}>
                    <div style={{ display: "flex", alignItems: "flex-start", whiteSpace: "pre-line" }}>
                        <div style={styleNameA}>
                            {`${found.Disc1_header_ar}\n${found.Disc1_header_en}`}
                        </div>
                    </div>
                    <div style={{ flexGrow: 1, }}></div>
                    <div >
                        <ButtonBase>
                            <img
                                src={`data:image/jpeg;base64,${found.Logo}`}
                                className={clas.Hedlogo}
                                alt={found.nameA}
                                style={{ height: 60, width: 60, margin: 0, padding: 0 }}
                            />
                        </ButtonBase>
                    </div>
                </Grid>
                <Grid container item xs={12} >
                    <div style={{ display: "flex", alignItems: "flex-end", textAlign: "left" }}>{"Page No"} {"   /"}{page} </div>
                    <div style={{ flexGrow: 1, }}></div>
                    <div style={styfOther}>
                        {`${locInv.ProcTypeInvProc === "03" || locInv.ProcTypeInvProc === "04" ? locInv.invN :
                            sta.tot.tax_no_cust === "" ? "فاتورة ضريبية مبسطة" + " " : "فاتورة ضريبية"}
                                    ${locInv.ProcTypeInvProc === "03" ? "QUOTATION" : locInv.ProcTypeInvProc === "04" ? "PURCHASE ORDER" :
                                sta.tot.tax_no_cust === "" ? "Simplified Tax Invoice" : "Tax Invoice"}`}
                    </div>
                    <div style={{ flexGrow: 1, }}></div>

                    <div style={{ display: "flex", alignItems: "flex-end", alignContent: "left" }}>
                        <div style={{ whiteSpace: "pre-line", fontWeight: "bold", }}>
                            {`${found.tax_no}\n${"CR No : "}${found?.bsn_no}`}
                        </div>
                        {inv.tax > 0 && (locInv.ProcTypeInvProc !== "03" || locInv.ProcTypeInvProc !== "04") &&
                            <div>{locInv?.Step_inv2 && inv?.ZatcaQR ?
                                <QRCodeCanvas value={inv?.ZatcaQR} />
                                :
                                <img
                                    src={`data:image/jpeg;base64,${inv.qr_image}`}
                                    style={{ height: 110, width: 110, outline: "none", boxShadow: "none", border: "none" }}
                                    alt={""}
                                />
                            }
                            </div>}
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <Divider style={{ background: "#000", height: 1.5 }} />
                    <Divider
                        style={{ background: "#000", marginTop: 3, height: 1.5 }}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}
export default NewHeadCom;